import { render, staticRenderFns } from "./AiView.vue?vue&type=template&id=9662aa12&scoped=true"
import script from "./AiView.vue?vue&type=script&lang=js"
export * from "./AiView.vue?vue&type=script&lang=js"
import style0 from "./AiView.vue?vue&type=style&index=0&id=9662aa12&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9662aa12",
  null
  
)

export default component.exports